import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import AIGeneratedDescriptionAllData from "./ai-generated-description-all-data";
import AIGeneratedDescriptionAllForm from "./ai-generated-description-all-form";

const AIGeneratedDescriptionAll = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_AI_GENERATED_DESCRIPTION_ALL",
      "DEVELOPER_AI_GENERATED_DESCRIPTION_ALL"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("DEV_ZONE")}
        subTitle={i18n.get("AI_GENERATED_DESCRIPTION_ALL")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <AIGeneratedDescriptionAllForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AIGeneratedDescriptionAllData />
    </ET3PageDiv>
  );
});

export default AIGeneratedDescriptionAll;
